export const REGISTER = 'REGISTER';
export const ORG = 'ORG';
export const UPDATE_ORG = 'UPDATE_ORG';
export const TOKEN = 'access_token';
export const CONTENT_LOCALES = 'available_supported_locales';
export const DEFAULT_LOCALE = 'default_locale';
export const PRIMARY_COLOR = 'primary_color_hex';
export const ESCALATION_ENTRIES = 'escalation_entries';
